module.exports = __webpack_public_path__ + "img/banner_cmz=1ZV7.ae94575e.png";